const Requesting = () => {
  return (
    <div id='requesting'>
      <h2>Processando sua compra</h2>
      <div className='content'>
        <span>Aguarde um momento...</span>
        <i className='la la-circle-notch la-spin mr-2' />
      </div>
    </div>
  );
};

export default Requesting;
